import { render, staticRenderFns } from "./common-back-header.vue?vue&type=template&id=61f155cf&scoped=true&"
import script from "./common-back-header.vue?vue&type=script&lang=js&"
export * from "./common-back-header.vue?vue&type=script&lang=js&"
import style0 from "./common-back-header.vue?vue&type=style&index=0&id=61f155cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f155cf",
  null
  
)

export default component.exports